import { Component, OnInit } from '@angular/core';
import { Ng2ImgMaxService } from 'ng2-img-max';

import { AuthenicationService } from '../../../_services/authenication.service';
import {environment} from '../../../../environments/environment';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {ToasterService} from "../../../_services/toaster.service";
import {UserService} from "../../../_services/user.service";
import {DoctorService} from "../../../_services/doctor.service";
import {CmsService} from "../../../_services/cms.service";
import {DynamicScriptLoaderServiceService} from "../../../_services/dynamic-script-loader-service.service";
import {first} from "rxjs/operators";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
declare var $: any;
import * as data from "../../../data.json";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  userdetaild: string;
  contactUsAllowedUsers: Array<string>;
  usersid: string;
  baseUrl: string = environment.baseUrl;
  editDocForm: FormGroup;
  userid: any;
  code: string;
  userdata: any;
  contactlist: any;
  returnUrl: string;
  submitted = false;
  selectedfile: File = null;
  selectedfile1: Array<File> = [];
  doctorid: string;
  imgtype = 'image/*';
  png = 'image/png';
  jpg = 'image/jpg';
  jpeg = 'image/jpeg';
  doc = 'application/msword';
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  pdf = 'application/pdf';
  imgKey: string = environment.imgKey;
  encodedKey: string;
  organizationPages: any[] = [];
  emp3Access: any  = (data  as  any).default
  // emp3Access = [
  //   {url:'watconsult', name:'Wat Consultant'},
  //   {url:'redcarpetup', name:'RedCarpetUp'},
  //   {url:'bira', name:'Bira'}, 
  //   {url:'jai-kisan', name:'Jai-Kisan'}, 
  //   {url:'amagi', name:'Amagi'}, 
  //   {url:'walchandpeoplefirst', name:'Walch and People First'}, 
  //   {url:'avon', name:'Avon'}, 
  //   {url:'joshtalks', name:'Josh Talks'}, 
  //   {url:'taboola', name:'Taboola'}, 
  //   {url:'nav-gurukul', name:'Nav Gurukul'},
  //   {url:'selldo', name:'selldo'}
  // ];

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private authenicationService: AuthenicationService, private toaster: ToasterService, private userservice: UserService, private doctorservice: DoctorService, private ng2ImgMax: Ng2ImgMaxService, private cmsService : CmsService) { }

  ngOnInit() {
    this.encodedKey = btoa(this.imgKey);
    this.userdetaild = this.authenicationService.userDetails();
    this.contactUsAllowedUsers = ["abhishek@mindpeerssubadmin.com"];
    this.getOrganizationPages();
    // console.log(this.userdetaild);
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.userid = this.userdetaild['_id'];

    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/selectpicker.js');

    this.editDocForm = this.formBuilder.group({
      users_name: ['', [Validators.required, Validators.minLength(3)]],
      photo: [''],
      users_mobile: ['', [Validators.required]],
      users_city: ['', [Validators.required]],
      // users_usertype: ['doctor', [Validators.required]],
      degree: ['', [Validators.required]],
      mental_health_prof: ['', [Validators.required]],
      experience: ['', [Validators.required]],
      language: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      about: ['', [Validators.required]],
      speciality: ['', [Validators.required]],
      certificates: [''],
      session_mode: ['', [Validators.required]],
      own_space: ['N/A', [Validators.required]],
      space_address: ['N/A', [Validators.required]],
    });

    if (this.userdetaild['users_usertype'] == 'doctor'){
      this.getDoctorProfile(this.userid);
    }

  }

  getDoctorProfile(id){
    this.doctorservice.getDoctorById(id)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.userdata = data.doctorsList[0];
            // console.log(this.userdata);
          } else {
            console.log('Doctor', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
        });
  }

  get f() { return this.editDocForm.controls; }

  fileUpload(event) {
    let image = event.target.files[0];
    if (image.type === this.jpg || image.type === this.png || image.type === this.jpeg) {

      this.ng2ImgMax.compressImage(image, 1, true).subscribe(
        result => {
          this.selectedfile = result;
        },
        error => {
          console.log(JSON.stringify(error));
          this.toaster.showError('😢 Oh no!', error);
        }
      );

      return true;
    } else {
      this.editDocForm.controls.photo.reset();
      this.toaster.showError('File Type', 'Only Images are allowed');
      return false;
    }
  }

  fileUpload1(event) {

    this.selectedfile1 = event.target.files as Array<File>;
    for (let i = 0; i < this.selectedfile1.length; i++) {
      if (this.selectedfile1[i].type === this.doc || this.selectedfile1[i].type === this.docx || this.selectedfile1[i].type === this.pdf) {
        return true;
      } else {
        this.editDocForm.controls.certificates.reset();
        this.toaster.showError('File Type', 'Only Documents are allowed');
        return false;
      }
    }
  }


  editForm(data: any) {
    // console.log(data);
    this.usersid = data.docid._id;
    this.doctorid = data._id;
    this.code = (data.docid.users_code)?data.docid.users_code:'';
    this.editDocForm.setValue({
      users_name: data.docid.users_name,
      users_mobile: data.docid.users_mobile,
      photo: '',
      users_city: data.docid.users_city,
      degree: data.degree,
      mental_health_prof: (data.mental_health_prof)?data.mental_health_prof:'',
      experience: data.experience,
      gender: (data.gender)?data.gender:'',
      about: (data.about)?data.about:'',
      language: data.language,
      speciality: data.speciality,
      certificates: '',
      own_space: (data.own_space)?data.own_space:'',
      session_mode: (data.session_mode)?data.session_mode:'',
      space_address: (data.space_address)?data.space_address:''
    });


  }

  onSubmit() {
    // stop here if form is invalid
    if (this.editDocForm.invalid) {
      return;
    }

    const addUserPayload = {
      users_name: this.editDocForm.controls.users_name.value,
      // users_email: this.editDocForm.controls.users_email.value,
      users_mobile: this.editDocForm.controls.users_mobile.value,
      users_city: this.editDocForm.controls.users_city.value,
      // users_password: this.editDocForm.controls.users_password.value,
      // users_status: this.editDocForm.controls.users_status.value,
      degree: this.editDocForm.controls.degree.value.toString(),
      mental_health_prof: this.editDocForm.controls.mental_health_prof.value,
      experience: this.editDocForm.controls.experience.value,
      gender: this.editDocForm.controls.gender.value,
      about: this.editDocForm.controls.about.value,
      language: this.editDocForm.controls.language.value.toString(),
      speciality: this.editDocForm.controls.speciality.value.toString(),
      session_mode: this.editDocForm.controls.session_mode.value,
      own_space: (this.editDocForm.controls.own_space.value)?this.editDocForm.controls.own_space.value:'N/A',
      space_address: (this.editDocForm.controls.space_address.value)?this.editDocForm.controls.space_address.value:'N/A',
    };

    const formdata = new FormData();

    formdata.append('users_name', addUserPayload.users_name);
    formdata.append('doc_id', this.doctorid);
    formdata.append('users_mobile', addUserPayload.users_mobile);
    formdata.append('users_city', addUserPayload.users_city);
    formdata.append('users_id', this.usersid);
    if (this.selectedfile !== null) {
      formdata.append('photo', this.selectedfile);
    }
    if (this.selectedfile1) {
      const files: Array<File> = this.selectedfile1;
      for (let i = 0; i < files.length; i++) {
        formdata.append('certificates', files[i], files[i].name);
      }
    }
    formdata.append('degree', addUserPayload.degree);
    formdata.append('mental_health_prof', addUserPayload.mental_health_prof);
    formdata.append('experience', addUserPayload.experience);
    formdata.append('gender', addUserPayload.gender);
    formdata.append('about', addUserPayload.about);
    formdata.append('language', addUserPayload.language);
    formdata.append('speciality', addUserPayload.speciality);
    formdata.append('session_mode', addUserPayload.session_mode);
    formdata.append('own_space', addUserPayload.own_space);
    formdata.append('space_address', addUserPayload.space_address);
    // console.log(formdata.getAll('photo'));
    this.updateDoctor(formdata);
  }

  updateDoctor(payload) {
    this.doctorservice.updateDoctor(payload)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            localStorage.setItem('userDetails', btoa(JSON.stringify(data.userData)));
            localStorage.setItem('JWT_TOKEN', btoa(data.jwt));
            localStorage.setItem('REFRESH_TOKEN', btoa(data.refreshToken));
            this.userdetaild = this.authenicationService.userDetails();
           // this.router.navigate(['/profile']);
            //this.toaster.showSuccess('Update Profile', data.ResponseMessage);
            //this.getDoctorProfile(this.userid);
            $('#ordine').modal('hide');
            location.reload();
          } else {
            this.toaster.showError('Update Profile', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Update Profile', error.error.ResponseMessage);
        });
  }

  getOrganizationPages(){
    this.cmsService.getOrganizationPages()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.organizationPages = data.Data;
            // console.log(this.userdata);
          } else {
            console.log('Doctor', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
        });
  }

}
